module.exports = __webpack_public_path__ + "static/media/calendar.9c4c1bd4.svg";